import { useEffect, useState } from "react";
import { fetchFromLocalStorage } from "../../../api/localStorage";

interface useLocalResultData {
    projectId: string;
}

interface AIMeasurement {
    [key: string]: number | AIMeasurement | undefined;
    GoodPercentage?: number;
    PoorPercentage?: number;
    BackgroundPercentage?: number;
    BackgroundMucinPercentage?: number;
    StromaPercentage?: number;
    MacrophagePercentage?: number;
    LymphocyteInfiltrateClusterPercentage?: number;
    TumorPercentage?: number;
    NecrosisPercentage?: number;
    TumorGhostPercentage?: number;
    withBackground?: AIMeasurement;
    withoutBackground?: AIMeasurement;
}

interface ResultData {
    'AI-Measurement': {
        withBackground?: AIMeasurement;
        withoutBackground?: AIMeasurement;
        [key: string]: any;
    };
}

interface localResultData {
    id: string;
    image_id: string;
    status: string;
    model_path?: string;
    updated_at: string;
    result_data?: ResultData[];
}

interface GroupedResults {
    [key: string]: localResultData[];
}

// Define a type for the lookup object where image_id is the key
interface LookupResultData {
    [image_id: string]: localResultData;
}

export default function useLocalResultData({ projectId }: useLocalResultData) {
    const [resultData, setResultData] = useState<GroupedResults>({});
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (projectId) {
            try {
                const fetchedData: localResultData[][] = fetchFromLocalStorage(projectId) || [];
                
                // Flatten the array of arrays and group by image_id
                const groupedResults: GroupedResults = {};
                fetchedData.flat().forEach((result: localResultData) => {
                    if (!groupedResults[result.image_id]) {
                        groupedResults[result.image_id] = [];
                    }
                    groupedResults[result.image_id].push(result);
                });
                
                setResultData(groupedResults);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching result data:', error);
                setIsError(true);
                setIsLoading(false);
            }
        }
    }, [projectId]);

    return { resultData, isLoading, isError };
}
